module.exports = "/_next/static/images/default-file-c477853150d5fdc59ee54716d779ce3c.jpg";